import { render } from "./collapse.vue?vue&type=template&id=d1b2c342&scoped=true"
import script from "./collapse.vue?vue&type=script&lang=js"
export * from "./collapse.vue?vue&type=script&lang=js"

import "./collapse.vue?vue&type=style&index=0&id=d1b2c342&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d1b2c342"

export default script